import categories from './categories.json';

export const getCategories = () => categories;